import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=1272c06f&scoped=true&"
import script from "./PageButton.vue?vue&type=script&lang=js&"
export * from "./PageButton.vue?vue&type=script&lang=js&"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=1272c06f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272c06f",
  null
  
)

export default component.exports